//! Polla GET /v1/markets/{slug}/resolution.
//!
//! Restituisce lo stato di risoluzione corrente (open / proposed / disputed /
//! finalized / resolved) + lista degli attempt dell'oracolo + countdown del
//! dispute window se applicabile.

import { useEffect, useState } from "react";

import { api } from "@/api/client";
import type { components } from "@/api/schema.gen";

export type ResolutionStatus = components["schemas"]["ResolutionStatusView"];
export type ResolutionAttempt = components["schemas"]["ResolutionAttemptView"];

export function useResolution(slug: string | undefined, intervalMs = 15_000) {
  const [data, setData] = useState<ResolutionStatus | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    const load = async () => {
      const res = await api.GET("/v1/markets/{slug}/resolution", {
        params: { path: { slug } },
      });
      if (cancelled) return;
      if (res.data) setData(res.data);
      setLoading(false);
    };
    load();
    const t = setInterval(load, intervalMs);
    return () => {
      cancelled = true;
      clearInterval(t);
    };
  }, [slug, intervalMs]);

  return { data, loading };
}
